import { useEffect } from "react";

export default function Seo({ data }: { data: object }) {
  useEffect(() => {
    const id = `jsonld-${Math.random().toString(36).slice(2)}`;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data]);

  return null;
}